import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  HostListener,
  TemplateRef,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, finalize, from, mergeMap, tap } from 'rxjs';
import Shell, { Options as SpreadsheetOptions, SheetData } from 'x-data-spreadsheet';
import { TablesService } from 'src/app/core/service/table.service';
import { ToastService } from 'src/app/toast/toast.service';
import { NgbModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import {
  ActiveSheetObservable,
  StructureObservable,
  FileUploadObservable,
  CreditCountObservable,
  UserInfoObservable,
  StateService,
  SidebarToggleObservable,
  WorkspacesObservable,
} from 'src/app/core/service/observable.service';
import { UserService } from 'src/app/core/service/user.service';
import {
  XSSheet,
  APISheet,
  TableList,
  ContainerSet,
  GetTableDto,
  CreateNewTableDto,
  FileUpload,
  GetSignedURLDto,
  FileAdditionalUploadDto,
  FileUploadDto,
  Provenance,
  Segment,
  CellClickedEvent,
  DocumentDataFileInfo,
} from './shell.model';
import { UUID } from '../../pages/aichat/aichat.model';
import { GoogleService } from 'src/app/core/service/google.service';
import { TableExtractorService, StructuringStatus } from 'src/app/core/service/table-extractor.service';
import { WebsocketService } from 'src/app/core/service/websocket.service';
import { StructureEvent } from 'src/app/core/models/websocket/structure';
import { FileUploadEvent } from 'src/app/core/models/websocket/fileupload';
import { SchemaConfig, SchemaResponse } from 'src/app/core/service/schema.service';
import { Config } from 'src/app/core/config/config';
import { SchemaSettingsModalComponent } from './schema-settings-modal/schema-settings-modal.component';
import { SchemaSettings } from './shell.model';
import { LocalStorageService, InterruptedUploadState } from 'src/app/core/service/local-storage.service';

interface StructureCountdownState {
  tableId: string;
  endTime: number;
  durationMs: number;
  startedAt: number;
}

export class ShellExt extends Shell {
  constructor(selector: string | HTMLElement, options: SpreadsheetOptions) {
    super(selector, options);
  }

  private getDimensions(sheet: SheetData): SheetData {
    if (!sheet.rows) sheet.rows = {};
    const maxRowKey: number = Math.max(
      ...Object.keys(sheet.rows).map((key) => {
        return Number(key) || 0;
      })
    );
    Object.assign(sheet.rows, { len: Math.max(maxRowKey + 100, 1000) });
    if (!sheet.cols) {
      sheet.cols = { len: 0 };
    }
    let maxColKey: number = 0;
    Object.values(sheet.rows).forEach((row) => {
      if (row.cells) {
        maxColKey = Math.max(
          maxColKey,
          ...Object.keys(row.cells).map((key) => {
            return Number(key) || 0;
          })
        );
      }
    });
    sheet.cols.len = Math.max(maxColKey + 100, 100);
    //@ts-ignore
    //prettier-ignore
    console.log(`Sheet ${sheet.name} has ${sheet.rows.len!} rows and ${sheet.cols.len} cols.`);
    return sheet;
  }

  // Override the loadData method
  override loadData(data: Record<string, any>): this {
    if (Array.isArray(data)) {
      return super.loadData(data.map(this.getDimensions));
    } else {
      return super.loadData(this.getDimensions(data));
    }
  }
}

@Component({
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss'],
  standalone: false,
})
export class ShellComponent implements OnInit, OnDestroy {
  schemaHasChanged = false;
  /** True when at least one file has been structured; used with schemaHasChanged to show mismatch warning. */
  hasStructuredFiles = false;
  /** Incremented when Structure API succeeds; schema-builder uses it to reset schema changed state. */
  structureSuccessTrigger = 0;

  private updateHasStructuredFiles(calledFrom: string): void {
    this.hasStructuredFiles = this.files.some((f) => f.isStructured);
  }
  private readonly defaultSchemaSettings: SchemaSettings = {
    requireProvenance: false,
    fastConversion: false,
    multiple_rows: false,
    schemaSplittingThreshold: 30,
    n_shot: 1
  };
  schemaSettings: SchemaSettings = { ...this.defaultSchemaSettings };
  schemaConfig: SchemaConfig | null = null;
  @ViewChild('chatSlide') chatSlide: ElementRef | undefined;
  @ViewChild('tableSlide') tableSlide: ElementRef | undefined;
  @ViewChild('dividerLine') dividerLine: ElementRef | undefined;
  @ViewChild('pdfPageLimitModal') pdfPageLimitModal!: any;
  @ViewChild('wrongFileTypeModal') wrongFileTypeModal!: any;
  @ViewChild('existingFileModal') existingFileModal!: any;
  @ViewChild('interruptedUploadModal') interruptedUploadModal!: TemplateRef<unknown>;
  @ViewChild('tooltip') tooltip!: NgbTooltip;
  activeTab: 'spreadsheet' | 'schema' | 'generating-schema' | 'integrations' | 'job-management' | 'document-data' = 'schema';
  private previousTab: 'spreadsheet' | 'schema' | 'generating-schema' | 'integrations' | 'job-management' | 'document-data' = 'schema';
  activeView: 'document' | 'content' = 'document';
  templateTabBlinking: boolean = false;
  isSidebarOpen: boolean = false;
  hasProvenance: boolean = false;
  hasDocumentHtml: boolean = false;
  selectedFileSegments: Segment[] = [];
  datasetRows: Array<{ [columnName: string]: any }> = [];
  
  _jsonSchema: string = '';
  _setupJsonSchema: boolean = false;
  get jsonSchema(): string {
    return this._jsonSchema;
  }
  set jsonSchema(value: string) {
    if (value === 'null') {
      this._jsonSchema = '';
      this._setupJsonSchema = false;
      return;
    } else if (value !== this._jsonSchema) {
      if (this._jsonSchema && this._setupJsonSchema && value) {
        // JSON schema was changed after initial setup
        this.files_unstructured_count = this.files.length;

        this.files = this.files.map((file) => {
          return {
            ...file,
            // isStructured: false,
          };
        });
        this.updateHasStructuredFiles('jsonSchema setter');
      } else if (value) {
        this._setupJsonSchema = true;
      } else {
        this._setupJsonSchema = false;
      }
      this._jsonSchema = value;
    }
  }

  chats: any;
  schema_id: string = '';
  schema_name: string = '';
  private isApplyingTemplateSilently: boolean = false;
  formIsValid: boolean = false;
  schemaIsDraft: boolean = false;
  tables: TableList = [];
  containers: ContainerSet = [];
  suggestions: string[] = [];
  fileName: string = '';
  activeSheet: XSSheet | APISheet | undefined;
  activeTableSheets: any[] | undefined;
  activeContainer: UUID | undefined = '';
  inputChat: string = '';
  showImportSheetModal = false;
  isSheetNameEdit: boolean = false;
  isXSEvtInitialized: boolean = false;
  editedSheetName: string = '';
  loading: boolean = false;
  isNewSheetCreated: boolean = false;
  private isLoadingTable: boolean = false;
  uploadFileLoading: boolean = false;
  _existingFiles: string[] = [];
  valid_MIME_types: string[] = [
    'application/pdf',
    'text/csv',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.oasis.opendocument.spreadsheet',
    'application/vnd.oasis.opendocument.text',
    'application/vnd.apple.numbers',
    'application/vnd.apple.pages',
    'image/png',
    'image/jpeg',
    'image/gif',
    'image/webp',
    'text/plain',
    'text/markdown',
    'audio/mpeg',
    'audio/wav',
    'audio/ogg',
    'application/vnd.ms-outlook',
    'application/zip',
    'application/x-zip-comprzipessed',
    'application/x-rar-compressed',
    'application/gzip',
    'application/x-7z-compressed',
    'application/json',
  ];

  valid_extensions: string[] = [
    '.pdf',
    '.csv',
    '.doc',
    '.docx',
    '.xls',
    '.xlsx',
    '.ods',
    '.odt',
    '.numbers',
    '.pages',
    '.png',
    '.jpg',
    '.jpeg',
    '.gif',
    '.webp',
    '.txt',
    '.md',
    '.markdown',
    '.mp3',
    '.wav',
    '.ogg',
    '.msg',
    '.zip',
    '.rar',
    '.gz',
    '.7z',
    '.json',
  ];

  valid_files = `${this.valid_MIME_types.join(
    ','
  )},${this.valid_extensions.join(',')}`;
  gOauthData: any;
  gOauthFlag = {
    analytics: false,
    ads: false,
  };
  isNewDataspaceCreated: boolean = true;
  spreadSheetLoading: boolean = false;
  cancelling: boolean = false;
  files: FileUpload[] = [];
  selected_file_index: number = 0;
  files_unstructured_count: number = 0;
  structuringTableId: string = '';

  signedUrl: string = '';
  _fileMimeType: string = '';
  tableHasFile: boolean = false;
  filesCurrentlyUploading: number = 0;
  isUploadInProgress: boolean = false;
  isManualModeUploadInProgress: boolean = false;
  processingProgress = {
    current: 0,
    total: 0,
    processedFiles: [] as string[],
    failedFiles: [] as string[],
  };
  creditCount: number = 0;
  estimatedProcessingTimeSeconds: number | null = null;
  structureButtonDisabled: boolean = false;
  private readonly STRUCTURE_COUNTDOWN_STORAGE_KEY = 'structureCountdownState';
  private readonly DEFAULT_PROCESSING_TIME_PER_FILE_SECONDS = 60;
  private structureCountdownIntervalId: ReturnType<typeof setInterval> | null =
    null;
  private structureCountdownState: StructureCountdownState | null = null;
  structureCountdownDisplay: string | null = null;
  workflowType: 'semi' | 'manual' | '' = 'semi';
  showSchemaBuilderPopup: boolean = false;
  schemaBuilderPopupTimeout: any;
  isCopied = false;
  isIdClicked: boolean = false;
  showJsonView = false;
  isDatasetJsonLoading = false;
  copyToClipboardIconPath = 'assets/img/icons/correlation_id_icon.png';
  isGeneratingSchema: boolean = false;
  private schemaGenerationStates: Map<string, {
    isGenerating: boolean;
    activeTab: string;
    tableHasFile: boolean;
    filesCurrentlyUploading: number;
    signedUrl: string;
    fileMimeType: string;
  }> = new Map();

  isDragging = false;
  leftPanelWidth = 50;
  private startX = 0;
  private startLeftWidth = 0;

  private _sheets: (XSSheet | APISheet)[] = [];
  get sheets(): (XSSheet | APISheet)[] {
    return this._sheets;
  }
  set sheets(value: (XSSheet | APISheet)[]) {
    this._sheets = value;
    if (this.isActiveTableStructuring && this.activeTab === 'job-management') {
      return;
    }

    if (!this.isApplyingTemplateSilently && !this.isGeneratingSchema) {
      this.activeTab =
        value.length === 0 || !Object.keys(value[0]?.rows || {}).length
          ? 'schema'
          : 'spreadsheet';
      console.log('sheets setter activeTab changed to:', this.activeTab);
    } else if (this.isGeneratingSchema) {
      console.log('sheets setter activeTab change blocked by schema generation');
    } else {
      console.log('sheets setter activeTab change blocked by silent flag');
    }
  }

  // Document Data tab state - shows data filtered by selected file
  documentDataSheets: (XSSheet | APISheet)[] = [];
  documentDataSheet: XSSheet | APISheet | undefined;
  documentDataLoading: boolean = false;
  documentDataFileInfo: DocumentDataFileInfo | null = null;
  private _documentDataRowCount: number = 0;

  /**
   * Get the row count for the document data (filtered by file)
   */
  getDocumentDataRowCount(): number {
    return this._documentDataRowCount;
  }

  get signedFileUrl(): string {
    return this.signedUrl;
  }
  set signedFileUrl(value: string) {
    this.signedUrl = value;
  }
  get fileMimeType(): string {
    return this._fileMimeType;
  }
  set fileMimeType(value: string) {
    this._fileMimeType = value;
  }
  get hasSufficientCredits(): boolean {
    return this.creditCount >= this.totalCreditsRequired;
  }
  setFile(value?: { mimeType?: string; signedUrl?: string } & any) {
    this.signedUrl = value?.signedUrl || '';
    this._fileMimeType = value?.mimeType || '';
  }

  constructor(
    private cdRef: ChangeDetectorRef,
    private tableService: TablesService,
    private toastService: ToastService,
    private modalService: NgbModal,
    private activeSheetObservable: ActiveSheetObservable,
    private userService: UserService,
    private googleService: GoogleService,
    private tableExtractor: TableExtractorService,
    private structureObservable: StructureObservable,
    private fileUploadObservable: FileUploadObservable,
    private creditCountObservable: CreditCountObservable,
    private userInfoObservable: UserInfoObservable,
    private websocketService: WebsocketService,
    private stateService: StateService,
    private sidebarToggleObservable: SidebarToggleObservable,
    private workspacesObservable: WorkspacesObservable,
    private http: HttpClient,
    private localStorageService: LocalStorageService
  ) {
    this.sheets = [];
  }

  ngOnInit(): void {
    this.leftPanelWidth = 50;

    localStorage.removeItem('leftPanelWidth');

    this.activeSheetObservable.tableId$.subscribe((tableId) => {
      if (!this.isLoadingTable && tableId) {
        this.loadTable(tableId).then(() => {
          this.checkStructuringStatus();
        });
      } else if (!tableId) {
        this.resetView();
      }
    });
    // subscribe from headers to update container when delete is triggered
    this.tableService.getUpdateNotification().subscribe((data: any) => {
      this.activeContainer = data.containerId;
    });
    this.subscribeToStructureObservable();
    this.subscribeToFileUploadObservable();
    this.subscribeToCreditCountObservable();
    this.subscribeToSidebarToggleObservable();
    this.initializeSidebarState();
    this.getOAuthUser();
    this.refreshCredits();
    this.restoreStructureCountdownFromStorage();
  }

  @HostListener('window:beforeunload')
  onBeforeUnload(): void {
    if (this.isUploadInProgress && this.activeTable) {
      this.saveInterruptedUploadToStorage();
    }
  }

  private saveInterruptedUploadToStorage(): void {
    this.localStorageService.setItem(this.localStorageService.keys.interruptedUpload, {
      tableId: this.activeTable,
    });
  }

  private clearInterruptedUploadStorage(): void {
    this.localStorageService.removeItem(this.localStorageService.keys.interruptedUpload);
  }

  private checkAndShowInterruptedUploadModal(tableId: string): void {
    const key = this.localStorageService.keys.interruptedUpload;
    const state = this.localStorageService.getItem<InterruptedUploadState>(key);
    if (!state || state.tableId !== tableId) return;
    this.localStorageService.removeItem(key);
    this.modalService.open(this.interruptedUploadModal, { centered: true });
  }

  checkStructuringStatus(): void {
    this.tableExtractor.getStructuringStatus().subscribe({
      next: (status: StructuringStatus) => {
        console.log('Structuring status:', status);

        if (status.isStructuring && status.tableId) {
          const tableId = status.tableId;

          this.structuringTableId = tableId;

          this.spreadSheetLoading = true;
          this.cancelling = false;
          this.restoreStructureCountdownFromStorage(tableId);

          if (tableId === this.activeTable || !this.activeTable) {
            // this.activeTable = tableId;
            this.setTableLoading(tableId, false);

            this.loadTable(tableId)
              .then(() => {
                this.files = this.files.map((file) => {
                  if (!file.isStructured) {
                    return {
                      ...file,
                      status: 'processing',
                    };
                  } else {
                    return file;
                  }
                });
                this.updateHasStructuredFiles('loadTable (processing)');

                this.processingProgress = {
                  current: 0,
                  total: this.files.filter((f) => !f.isStructured).length,
                  processedFiles: [],
                  failedFiles: [],
                };

                this.activeTab = 'job-management';

                this.websocketService.connect().subscribe({
                  next: (socketId) => {
                    if (socketId) {
                      console.log(
                        'WebSocket connected for ongoing structuring updates'
                      );
                    }
                  },
                  error: (error) => {
                    console.error(
                      'Failed to establish WebSocket connection:',
                      error
                    );
                  },
                });

                this.cdRef.detectChanges();
              })
              .catch((error) => {
                console.error(
                  'Error loading table for structuring status:',
                  error
                );
                this.spreadSheetLoading = false;
                this.structuringTableId = '';
                this.setTableLoading(tableId, true);
              });
          } else {
            this.setTableLoading(tableId, false);
          }

          console.log(
            `Resuming structuring process for table ${tableId} with ${status.jobCount} jobs`
          );
        } else {
          this.structuringTableId = '';
          this.spreadSheetLoading = false;
          this.clearStructureCountdown();
        }
      },
      error: (error) => {
        console.error('Error checking structuring status:', error);
        this.structuringTableId = '';
      },
    });
  }

  setActiveTab(tab: 'spreadsheet' | 'schema' | 'generating-schema' | 'integrations' | 'job-management' | 'document-data') {
    if (tab !== this.activeTab) {
      this.showJsonView = false;
    }

    if (this.isGeneratingSchema) {
      return;
    }

    if (
      this.activeTab === 'generating-schema' &&
      (tab === 'schema' || tab === 'generating-schema')
    ) {
      // Don't switch tab to schema-related views if one is currently being generated
      return;
    }

    if (this.isActiveTableStructuring && this.activeTab === 'job-management' && tab !== 'job-management') {
      return;
    }

    this.previousTab = this.activeTab;
    this.activeTab = tab;

    if (tab === 'document-data') {
      this.loadDocumentData();
    }
  }

  async toggleJsonView(): Promise<void> {
    if (this.showJsonView) {
      this.showJsonView = false;
      return;
    }

    if (this.activeTab === 'spreadsheet' && !this.datasetRows.length && this.sheets?.length) {
      this.isDatasetJsonLoading = true;
      await this.loadDatasetRowsForJson();
      this.isDatasetJsonLoading = false;
    }

    if (this.activeTab === 'document-data' && !this.documentDataSheet) {
      await this.loadDocumentData();
    }

    this.showJsonView = true;
  }

  getDocumentJsonSchemaString(): string {
    const rows = this.extractRowsFromSheet(this.documentDataSheet);
    const normalized = this.normalizeRowsForJson(rows);
    return JSON.stringify(normalized, null, 2);
  }

  getDatasetJsonSchemaString(): string {
    if (!this.datasetRows.length && this.sheets?.length) {
      this.datasetRows = this.sheets.flatMap((sheet) => this.extractRowsFromSheet(sheet));
    }
    const normalized = this.normalizeRowsForJson(this.datasetRows);
    return JSON.stringify(normalized, null, 2);
  }

  private extractRowsFromSheet(sheet: any): any[] {
    if (!sheet) {
      return [];
    }
    if (Array.isArray(sheet.rows)) {
      return sheet.rows;
    }
    if (sheet.rows && typeof sheet.rows === 'object') {
      return Object.keys(sheet.rows)
        .filter((key) => key !== 'len')
        .map((key) => {
          const row = sheet.rows[key];
          if (row?.cells) {
            const rowObj: Record<string, any> = {};
            Object.keys(row.cells).forEach((colKey) => {
              const cell = row.cells[colKey];
              rowObj[colKey] = cell?.text ?? cell?.value ?? cell;
            });
            return rowObj;
          }
          return row;
        });
    }
    return [];
  }

  private normalizeRowsForJson(rows: any[]): any[] {
    if (!rows.length) {
      return rows;
    }

    const headerRow = rows[0];
    const headerKeys = headerRow && typeof headerRow === 'object' ? Object.keys(headerRow) : [];
    const hasNumericKeys = headerKeys.length > 0 && headerKeys.every((key) => /^\d+$/.test(key));
    const headerValues = hasNumericKeys ? headerKeys.map((key) => headerRow[key]) : [];
    const hasStringHeaders = headerValues.length > 0 && headerValues.every((value) => typeof value === 'string');

    if (!hasNumericKeys || !hasStringHeaders) {
      return rows;
    }

    const headers = headerKeys
      .sort((a, b) => Number(a) - Number(b))
      .map((key) => headerRow[key]);

    return rows.slice(1).map((row) => {
      const rowObj: Record<string, any> = {};
      headers.forEach((header, index) => {
        const value = row?.[String(index)];
        rowObj[header] = value !== undefined ? value : null;
      });
      return rowObj;
    });
  }

  private async loadDatasetRowsForJson(): Promise<void> {
    this.datasetRows = [];
    for (const sheet of this.sheets || []) {
      try {
        const data = await this.tableService.getSheetData(sheet.id, true);
        const rows = this.extractRowsFromSheet(data?.sheet);
        if (rows.length) {
          this.datasetRows.push(...rows);
        }
      } catch (error) {
        console.error('Failed to load sheet data for dataset JSON:', error);
      }
    }
  }
  
  setActiveView(view: 'document' | 'content') {
    this.activeView = view;
  }

  private _documentDataLoadId = 0;
  
  async loadDocumentData(): Promise<void> {
    const loadId = ++this._documentDataLoadId;
    const selectedFileId = this.files[this.selected_file_index]?.id;
    const selectedFileName = this.files[this.selected_file_index]?.fileName;
    
    if (!selectedFileId) {
      this.documentDataSheets = [];
      this.documentDataSheet = undefined;
      this.documentDataFileInfo = null;
      this._documentDataRowCount = 0;
      return;
    }

    if (!this.sheets || this.sheets.length === 0) {
      this.documentDataSheets = [];
      this.documentDataSheet = undefined;
      this.documentDataFileInfo = null;
      this._documentDataRowCount = 0;
      return;
    }

    this.documentDataLoading = true;
    this.cdRef.detectChanges();

    try {
      this.documentDataFileInfo = {
        id: selectedFileId,
        fileName: selectedFileName || '',
        mimeType: this.files[this.selected_file_index]?.mimeType || '',
        uploadedAt: String(this.files[this.selected_file_index]?.uploadedAt || ''),
        jobId: this.files[this.selected_file_index]?.jobId || '',
        score: this.files[this.selected_file_index]?.scoring?.score || 0,
        quality: this.files[this.selected_file_index]?.scoring?.quality || '',
        summary: this.files[this.selected_file_index]?.scoring?.summary || undefined
      };

      const filteredSheets: APISheet[] = [];
      
      for (const sheet of this.sheets) {
        if (loadId !== this._documentDataLoadId) return;
        
        try {
          const sheetData = await this.tableService.getSheetData(sheet.id, true);
          
          if (loadId !== this._documentDataLoadId) return;
          
          if (sheetData?.sheet) {
            const fullSheet = sheetData.sheet as APISheet;
            
            if (Array.isArray(fullSheet.rows) && Array.isArray(fullSheet.rowsMeta)) {
              const filteredRows: any[] = [];
              const filteredRowsMeta: any[] = [];
              
              for (let i = 0; i < fullSheet.rows.length; i++) {
                const rowMeta = fullSheet.rowsMeta[i];
                if (rowMeta) {
                  const fileIdCounts: { [key: string]: number } = {};
                  
                  for (const [key, cellMeta] of Object.entries(rowMeta)) {
                    if (cellMeta && typeof cellMeta === 'object') {
                      const meta = cellMeta as any;
                      const fid = meta.fileId || meta.file_id;
                      if (fid) {
                        fileIdCounts[fid] = (fileIdCounts[fid] || 0) + 1;
                      }
                    }
                  }
                  
                  const rowMetaAny = rowMeta as any;
                  const rowLevelFileId = rowMetaAny.fileId || rowMetaAny.file_id;
                  if (rowLevelFileId) {
                    fileIdCounts[rowLevelFileId] = (fileIdCounts[rowLevelFileId] || 0) + 1;
                  }
                  
                  let dominantFileId = '';
                  let maxCount = 0;
                  for (const [fid, count] of Object.entries(fileIdCounts)) {
                    if (count > maxCount) {
                      maxCount = count;
                      dominantFileId = fid;
                    }
                  }
                  
                  if (dominantFileId === selectedFileId) {
                    filteredRows.push(fullSheet.rows[i]);
                    filteredRowsMeta.push(rowMeta);
                  }
                }
              }
              
              if (filteredRows.length > 0) {
                const filteredSheet: APISheet = {
                  ...fullSheet,
                  rows: filteredRows,
                  rowsMeta: filteredRowsMeta
                };
                filteredSheets.push(filteredSheet);
              }
            }
          }
        } catch (sheetError) {
        }
      }
      
      if (loadId !== this._documentDataLoadId) return;
      
      if (filteredSheets.length > 0) {
        this.documentDataSheets = filteredSheets;
        this.documentDataSheet = filteredSheets[0];
        this._documentDataRowCount = filteredSheets[0].rows.length;
      } else {
        this.documentDataSheets = [];
        this.documentDataSheet = undefined;
        this._documentDataRowCount = 0;
      }
    } catch (error) {
      if (loadId !== this._documentDataLoadId) return;
      
      this.documentDataSheets = [];
      this.documentDataSheet = undefined;
      this.documentDataFileInfo = null;
      this._documentDataRowCount = 0;
    } finally {
      if (loadId === this._documentDataLoadId) {
        this.documentDataLoading = false;
        this.cdRef.detectChanges();
      }
    }
  }

  isCorrelationIdAvailable(): boolean {
    return !!this.stateService.getCorrelationId();
  }

  copyToClipboardClick() {
    const correlationId = this.stateService.getCorrelationId();

    navigator.clipboard.writeText(correlationId).then(() => {
      this.isCopied = true;
      this.isIdClicked = true;
      this.tooltip.open();

      setTimeout(() => {
        this.isCopied = false;
        this.isIdClicked = false;
        this.tooltip.close();
      }, 1000);
    });
  }

  setCopyToClipboardIcon(iconPath?: string) {
    if (iconPath) {
      this.copyToClipboardIconPath = iconPath;
    }
  }

  setCurrentTableLoading(unset: boolean = false, name?: string) {
    if (this.activeTable) {
      let activeTableItemIndex = this.tables.findIndex(
        (table) => table.tableId == this.activeTable
      );
      if (activeTableItemIndex > -1) {
        console.log(
          'Toggle loading of active table index ',
          activeTableItemIndex
        );
        this.tables[activeTableItemIndex].loading = !unset;
        if (name) {
          this.tables[activeTableItemIndex].tableName = name;
        }
      }
    }
  }

  setTableLoading(tableId: string, unset: boolean = false) {
    if (tableId) {
      // Check in main tables list
      let tableItemIndex = this.tables.findIndex(
        (table) => table.tableId == tableId
      );
      if (tableItemIndex > -1) {
        console.log('Toggle loading of table at index ', tableItemIndex);
        this.tables[tableItemIndex].loading = !unset;
        return;
      }

      this.containers.forEach((container) => {
        const table = container.tables.find((t) => t.tableId === tableId);
        if (table) {
          console.log(
            'Toggle loading of table in container ',
            container.containerName
          );
          table.loading = !unset;
        }
      });
    }
  }

  ngAfterViewInit() {}

  async loadData(sheetId: string, sheetOnly?: boolean): Promise<void> {
    const data = await this.tableService.getSheetData(sheetId, sheetOnly);
    console.log('Loading data for sheet:', sheetId);
    if (data) {
      this.activeTableName = data.tableName;
      this.activeContainer = data.containerId;
      this.activeSheet = data.sheet;
      if (!sheetOnly) {
        this.chats = data.chats || [];
        this.suggestions = data.suggestions || [];
        this.tableService.setTableChats(data.chats, data.suggestions);
      }
      this.sheets = data.sheets as (XSSheet | APISheet)[];
      this.isNewSheetCreated = false;
      this.tableService.sendData(data);
    }
  }

  resetView(tableData?: GetTableDto['data'], fromFileUpload?: boolean) {
    if (tableData) {
      console.log('ResetView with tableData', tableData);

      this.activeView = 'document';
      if (this.activeTableName !== tableData.tableName) {
        this.workspacesObservable.registerNewUpdate({
          type: 'rename',
          tableId: tableData.tableId,
          value: tableData.tableName,
        });
      }

      if (!fromFileUpload) {
        // We're coming from a recently uploaded file in an existing dataspace, so don't refresh what's already there
        this.setFile(tableData.file);
        this.filesCurrentlyUploading = 0;
        this.selected_file_index = 0;

        this.hasProvenance = (tableData.files?.[this.selected_file_index]?.provenance?.segments?.length ?? 0) > 0;
        if (this.hasProvenance) {
          this.setSelectedFileSegments(tableData.files![this.selected_file_index].provenance!.segments || []);
        } else {
          this.setSelectedFileSegments([]);
        }

        if (!this.isApplyingTemplateSilently) {
          if (this.structuringTableId === tableData.tableId && this.spreadSheetLoading) {
            this.activeTab = 'job-management';
          } else if (this.activeTab !== 'job-management') {
            this.activeTab =
              this.sheets.length === 0 ||
              !Object.keys(this.sheets[0].rows || {}).length
                ? 'schema'
                : 'spreadsheet';
            console.log('resetView activeTab changed to:', this.activeTab);
          }
        } else {
          console.log('resetView activeTab change blocked by silent flag');
        }
      }

      if (this.activeTable !== tableData.tableId) {
        this.activeTable = tableData.tableId || '';
      }
      
      const savedState = this.schemaGenerationStates.get(tableData.tableId || '');
      if (savedState) {
        this.isGeneratingSchema = savedState.isGenerating;
        if (savedState.isGenerating) {
          this.activeTab = 'generating-schema';
          this.tableHasFile = savedState.tableHasFile;
          this.filesCurrentlyUploading = savedState.filesCurrentlyUploading;
          this.signedUrl = savedState.signedUrl;
          this._fileMimeType = savedState.fileMimeType;
          console.log('Restored schema generation state for table:', tableData.tableId, {
            isGeneratingSchema: this.isGeneratingSchema,
            activeTab: this.activeTab,
            showRightSlide: this.showRightSlide
          });
          this.cdRef.detectChanges();
        }
      } else {
        this.isGeneratingSchema = false;
      }
      
      this.activeTableName = tableData.tableName;
      this.activeContainer = tableData.containerId;
      this.chats = tableData.chats;
      this.schema_id = tableData.schema_id || '';
      this.schema_name = tableData.schema_name || '';

      if (tableData.estimatedProcessingTimeSeconds != null) {
        this.estimatedProcessingTimeSeconds =
          tableData.estimatedProcessingTimeSeconds;
      }

      // Handle both legacy XSheets and new APISheets for backward compatibility. should be removed in the future.
      this.sheets =
        tableData.APISheets && tableData.APISheets.length > 0
          ? tableData.APISheets
          : tableData.XSheets || [];

      this.activeSheet = this.sheets[0] || undefined;

      this.schemaSettings = this.getSchemaSettings(tableData.schema_config);
      this.schemaConfig = tableData.schema_config || null;

      let jsonSchema = '';
      if (tableData.json_schema) {
        jsonSchema =
          typeof tableData.json_schema === 'string'
            ? JSON.stringify(JSON.parse(tableData.json_schema), null, 2)
            : JSON.stringify(tableData.json_schema, null, 2);
      }
      this.jsonSchema = jsonSchema;

      if (!jsonSchema) {
        this._setupJsonSchema = false;
      }
      this.files = tableData.files || [];
      this.updateHasStructuredFiles('loadTable');
      this.files_unstructured_count = this.files.filter(
        (f) => !f.isStructured
      ).length;
      this.tableHasFile = this.files.length > 0;
      this.isNewDataspaceCreated = false;
      this.schemaIsDraft = tableData.schemaIsDraft || false;

      const dataToSend = {
        ...tableData,
        sheets: this.sheets,
        XSheets: tableData.XSheets,
        APISheets: tableData.APISheets,
      };
      this.tableService.sendData(dataToSend);
      this.isNewSheetCreated = false;
      this.resetSegmentView();

      this.cdRef.detectChanges();

      this.files.forEach((file) => {
        if (!file.signedUrl && file.resourceKey) {
          this.tableService.getSignedURL(file.resourceKey!).subscribe({
            next: (_res: GetSignedURLDto) => {
              if (_res.data) {
                file.signedUrl = _res.data;
                this.cdRef.detectChanges();
              }
            },
            error: () => {
              console.error('Error getting signed URL for file:', file.resourceKey);
            },
          });
        }
      });
    } else {
      console.log('ResetView with no tableData');
      //this.activeTable = '';
      this.activeTableName = '';
      this.activeContainer = '';
      this.chats = '';
      this.sheets = [];
      this.suggestions = [];
      this.files = [];
      this.updateHasStructuredFiles('resetView');
      this.files_unstructured_count = 0;
      this.tableHasFile = false;
      this.isNewDataspaceCreated = true;
      this.selected_file_index = 0;
      this.filesCurrentlyUploading = 0;
      this.isGeneratingSchema = false; 
      this.isManualModeUploadInProgress = false; 
      this.isUploadInProgress = false; 
      this.activeSheet = undefined;
      if (!this.isApplyingTemplateSilently) {
        this.activeTab = 'schema';
        console.log('resetView (no tableData) activeTab changed to schema');
      } else {
        console.log(
          'resetView (no tableData) activeTab change blocked by silent flag'
        );
      }
      this.setFile();
      this.resetSegmentView();
      this.jsonSchema = '';
      this.schemaIsDraft = false;
    }
    this.cdRef.detectChanges();
  }

  setSelectedFileSegments(segments: Segment[]) {
    this.selectedFileSegments = (segments || []).map(segment => ({
      ...segment,
      html: segment.html
        .replace(/<p[^>]*>Image Captions:?<\/p>/gi, '') // Remove "Image Captions:" heading
        .replace(/<p[^>]*>\[Image\s+\d+\][^<]*<\/p>/gi, '') // Remove image caption paragraphs
        .replace(/\s*\[Image\s+\d+\]\s*/gi, '') // Remove standalone image placeholders
        .replace(/\n\s*\n\s*\n/g, '\n\n') // Clean up extra newlines
        .trim()
    }));
    this.hasDocumentHtml = this.selectedFileSegments.length > 0;
    this.cdRef.detectChanges();
  }

  async loadTable(tableId: UUID, fromFileUpload?: boolean) {

    console.log('Loading table:', tableId);

    if (this.isLoadingTable) {
      return Promise.resolve(false);
    }

    this.isLoadingTable = true;
    this.showJsonView = false;
    this.datasetRows = [];
    this.documentDataSheets = [];
    this.documentDataSheet = undefined;
    
    if (!fromFileUpload) {
      this.activeTable = tableId;
      this.sheets = [];
      this.activeSheet = undefined;
      this.loading = true;
      this.cdRef.detectChanges();
    }
    
    return new Promise<boolean>((resolve, reject) => {
      this.tableService.getTable(tableId).subscribe({
        next: (res: GetTableDto) => {
          this.loading = false;
          if (res.data) {
            this.resetView(res.data, fromFileUpload);
            if (!fromFileUpload) {
              this.checkAndShowInterruptedUploadModal(tableId);
            }
            resolve(true);
          } else {
            resolve(false);
          }
          this.isLoadingTable = false;
        },
        error: (err) => {
          this.loading = false;
          this.isLoadingTable = false;
          reject(err);
        },
      });
    });
  }

  async selectFile(file_index: number, use_cached_signed_url: boolean = false) {
    return new Promise<void>((resolve, reject) => {
      if (this.files[file_index]) {
        if (use_cached_signed_url && this.files[file_index].signedUrl) {
          this.setFile(this.files[file_index]);
        } else {
          if (this.files[file_index].resourceKey) {
            this.tableService
              .getSignedURL(this.files[file_index].resourceKey)
              .subscribe((_res: GetSignedURLDto) => {
                if (_res.data) {
                  this.files[file_index].signedUrl = _res.data;
                  this.setFile(this.files[file_index]);
                  this.setSelectedFileSegments(this.files[file_index].provenance?.segments || []);
                  this.cdRef.detectChanges();
                  resolve();
                } else {
                  reject(new Error('Failed to get file data'));
                }
              });
          } else {
            reject(new Error('File resource key not found'));
          }
        }
        this.selected_file_index = file_index;
        
        // Refresh document data if on the document-data tab
        if (this.activeTab === 'document-data') {
          this.loadDocumentData();
        }
        
        this.cdRef.detectChanges();
      } else {
        reject(new Error('File index out of bounds'));
      }
    });
  }

  isFileValid(file: File): boolean {
    const extension = '.' + (file.name.toLowerCase().split('.').pop() || '');
    return (
      this.valid_MIME_types.includes(file.type) ||
      this.valid_extensions.includes(extension)
    );
  }

  async confirmFiles(files: File[]): Promise<File[]> {
    // Find files already existing in the table, list them in the modal and ask whether to append or skip them
    const existingFiles = this.files.filter(f => files.some(file => file.name === f.fileName));
    if (existingFiles.length > 0) {
      const modalRef = this.modalService.open(this.existingFileModal, { centered: true, backdrop: 'static' });
      const fileNames = existingFiles.map(f => f.fileName);
      this._existingFiles = fileNames;
      return modalRef.result.then((result: 'append' | 'skip' | undefined) => {
        if (result === 'append') {
          return Promise.resolve(files);
        } else if (result === 'skip') {
          return Promise.resolve(files.filter(file => !existingFiles.some(f => f.fileName === file.name)));
        } else {
          return Promise.resolve(files);
        }
      }) as Promise<File[]>;
    }
    return Promise.resolve(files);
  }

  async onSubItemDrop(event: any, isDrop?: boolean): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      let droppedFiles: File[];

      if (isDrop) {
        droppedFiles = event;
      } else {
        droppedFiles = Array.from(event.target.files);
      }

      if (!droppedFiles || droppedFiles.length === 0) {
        resolve();
        return;
      }

      const invalidFiles = droppedFiles.filter(
        (file) => !this.isFileValid(file)
      );

      if (invalidFiles.length > 0) {
        this.modalService.open(this.wrongFileTypeModal, {
          centered: true,
        });
        resolve();
        return;
      }

      this.confirmFiles(droppedFiles).then((confirmedFiles) => {
        droppedFiles = confirmedFiles;
        if (!droppedFiles || droppedFiles.length === 0) {
          resolve();
          return;
        }
  
        const totalFiles = droppedFiles.length;
        this.filesCurrentlyUploading = totalFiles;
        this.isUploadInProgress = true;
        this.saveInterruptedUploadToStorage();
        const lastUploadedFileName = droppedFiles[droppedFiles.length - 1]?.name;

        from(droppedFiles)
          .pipe(
            mergeMap((file: File, index: number) => {
              const formData = new FormData();
              formData.append('file', file);
              formData.append('keep_existing_table_name', 'true');
  
              console.log(
                `Starting upload #${index + 1}/${totalFiles}:`,
                file.name
              );
  
              return this.tableService
                .uploadFileInDataspace(formData, this.activeTable, true)
                .pipe(
                  tap((res: FileAdditionalUploadDto) => {
                    if (res.data?.files) {
                      this.files = res.data.files;
                      this.updateHasStructuredFiles('uploadFileInDataspace');
                      this.files_unstructured_count = this.files.filter(
                        (f) => !f.isStructured
                      ).length;
                    }
                    if (res.data?.estimatedProcessingTimeSeconds != null) {
                      this.estimatedProcessingTimeSeconds = res.data.estimatedProcessingTimeSeconds;
                    }
                  }),
                  catchError((err) => {
                    console.error(`Upload failed for`, file.name, err);
                    this.handleFileUploadError(err);
                    return [];
                  }),
                  finalize(() => {})
                );
            }, 10),
            finalize(() => {
              this.filesCurrentlyUploading = 0;
              this.isUploadInProgress = false;
              this.clearInterruptedUploadStorage();

              if (this.activeTable) {
                this.loadTable(this.activeTable, true).finally(async () => {
                  const idx =
                    lastUploadedFileName
                      ? this.files.findIndex((f) => f.fileName === lastUploadedFileName)
                      : -1;
                  const targetIndex = idx >= 0 ? idx : Math.max(this.files.length - 1, 0);
                  if (this.files[targetIndex]) {
                    await this.selectFile(targetIndex, false);
                  }
                  this.cdRef.detectChanges();
                  resolve();
                });
              } else {
                this.cdRef.detectChanges();
                resolve();
              }
            })
          )
          .subscribe();
      });
    });
  }

  async onItemDrop(
    event: any,
    isDrop?: boolean,
    dataspaceCreated?: boolean,
    workspaceName?: string,
    selectedTemplate?: SchemaResponse
  ) {
    let _uploadFile: any;
    let _additionalFiles: any[] = [];
    if (isDrop) {
      _uploadFile = event[0];
      if (event.length > 1) {
        _additionalFiles = event.slice(1);
      }
    } else {
      _uploadFile = event[0];
      if (event.length > 1) {
        _additionalFiles = event.slice(1);
      }
    }

    if (!this.isFileValid(_uploadFile)) {
      this.modalService.open(this.wrongFileTypeModal, { centered: true });
      return;
    }

    const formData = new FormData();
    formData.append('file', _uploadFile);

    if (this.formIsValid) {
      formData.append('json_schema', this.jsonSchema);
    }

    // Generate a schema if user didn't choose to create one manually
    formData.append(
      'generate_schema',
      this.workflowType === 'semi' ? 'true' : ''
    );

    const activeTableName =
      this.activeTableName ||
      this.tables.find((table) => table.tableId == this.activeTable)
        ?.tableName ||
      '';
    this.fileName = _uploadFile.name;
    const uploadedPrimaryFileName = _uploadFile?.name as string | undefined;

    if (!dataspaceCreated || !this.activeTable) {
      // File dragged without dataspace reference, so we create one before moving on
      console.log('Creating dataspace');
      await this.newWorkspaceOrDataset('', 'dataspace', workspaceName);
      
      if (workspaceName && workspaceName.trim()) {
        formData.append('keep_existing_table_name', 'true');
      } else {
        formData.append('keep_existing_table_name', 'false');
      }
    } else {
      console.log(
        'Dataspace already created, activeTable, dataspaceCreated:',
        this.activeTable,
        dataspaceCreated
      );
      formData.append('keep_existing_table_name', 'true');
    }

    this.setCurrentTableLoading(
      false,
      this.fileName.split('.').slice(0, -1).join('.')
    );

    this.filesCurrentlyUploading = 1 + _additionalFiles.length;
    this.isUploadInProgress = true;
    this.saveInterruptedUploadToStorage();

    if (this.workflowType === 'manual') {
      this.isManualModeUploadInProgress = true;
    }

    if (this.workflowType === 'semi') {
      this.isGeneratingSchema = true;
      this.activeTab = 'generating-schema';
      this.schemaGenerationStates.set(this.activeTable, {
        isGenerating: true,
        activeTab: 'generating-schema',
        tableHasFile: this.tableHasFile,
        filesCurrentlyUploading: this.filesCurrentlyUploading,
        signedUrl: this.signedUrl,
        fileMimeType: this._fileMimeType
      });
      console.log('Started schema generation for table:', this.activeTable, {
        isGeneratingSchema: this.isGeneratingSchema,
        activeTab: this.activeTab,
        showRightSlide: this.showRightSlide
      });
    }

    this.tableService
      .uploadFileInDataspace(formData, this.activeTable)
      .subscribe({
        next: async (res: FileUploadDto) => {
          console.log(res);

          // Store estimated processing time from initial upload (if provided)
          if (res.data?.estimatedProcessingTimeSeconds != null) {
            this.estimatedProcessingTimeSeconds = res.data.estimatedProcessingTimeSeconds;
          }

          // this.activeTableName = res.data.tableName;
          this.loadTable(res.data.tableId, true).then(async () => {
            const idx =
              uploadedPrimaryFileName
                ? this.files.findIndex((f) => f.fileName === uploadedPrimaryFileName)
                : -1;
            const targetIndex = idx >= 0 ? idx : Math.max(this.files.length - 1, 0);
            if (this.files[targetIndex]) {
              await this.selectFile(targetIndex, false);
            }

            this.fileName = '';
            this.setCurrentTableLoading(true);

            if (this.workflowType !== 'semi') {
              
              this.isUploadInProgress = false;
            }

            if (selectedTemplate && this.workflowType === 'manual') {
              await this.applySelectedTemplate(selectedTemplate);
            } else if (this.workflowType === 'manual' && _additionalFiles.length === 0) {
              setTimeout(() => {
                this.filesCurrentlyUploading = 0;
                this.clearInterruptedUploadStorage();
                this.isManualModeUploadInProgress = false;
                this.cdRef.detectChanges();
              }, 0);
            }

            if (_additionalFiles.length > 0) {
              await this.onSubItemDrop(_additionalFiles, true);
              
              if (this.workflowType === 'manual') {
                setTimeout(() => {
                  this.filesCurrentlyUploading = 0;
                  this.isManualModeUploadInProgress = false;
                  this.cdRef.detectChanges();
                }, 0);
              }
            }

            this.workspacesObservable.registerNewUpdate({
              type: 'change',
              tableId: this.activeTable,
            });

            if (this.workflowType === 'semi') {
              this.isGeneratingSchema = false;
              this.filesCurrentlyUploading = 0;
              this.isUploadInProgress = false;
              if (_additionalFiles.length === 0) {
                this.clearInterruptedUploadStorage();
              }
              this.schemaGenerationStates.set(this.activeTable, {
                isGenerating: false,
                activeTab: 'schema',
                tableHasFile: this.tableHasFile,
                filesCurrentlyUploading: this.filesCurrentlyUploading,
                signedUrl: this.signedUrl,
                fileMimeType: this._fileMimeType
              });

              if (!this.isApplyingTemplateSilently) {
                this.activeTab = 'schema';
              }
              if (res.data.generated_schema) {
                this.toastService.show(
                  'info',
                  'Talonic created this template for your spreadsheet based on your document. You can change it at any time later.',
                  {
                    classname:
                      'bg-white text-dark position-fixed bottom-0 end-0 mb-7 me-3',
                  }
                );
                this.templateTabBlinking = true;
                setTimeout(() => {
                  this.templateTabBlinking = false;
                }, 3000); // Stop blinking after 3 seconds
                this.showSchemaBuilderTooltip();
              } else {
                if (!this.isApplyingTemplateSilently) {
                  this.activeTab = 'schema';
                }
                this.toastService.show(
                  'Info',
                  "The file was successfully uploaded, but we couldn't generate a template for it. Please create a template manually.",
                  {
                    classname:
                      'bg-white text-dark position-fixed bottom-0 end-0 mb-7 me-3',
                  }
                );
              }
            }
          });
        },
        error: (err: any) => {
          this.fileName = '';
          this.setCurrentTableLoading(true, activeTableName);
          this.activeTab = 'spreadsheet';
          this.filesCurrentlyUploading--;
          this.isGeneratingSchema = false;
          this.isUploadInProgress = false;
          this.isManualModeUploadInProgress = false;
          this.schemaGenerationStates.set(this.activeTable, {
            isGenerating: false,
            activeTab: 'spreadsheet',
            tableHasFile: this.tableHasFile,
            filesCurrentlyUploading: this.filesCurrentlyUploading,
            signedUrl: this.signedUrl,
            fileMimeType: this._fileMimeType
          });

          this.handleFileUploadError(err);
        },
      });
  }

  handleFileUploadError(err: any) {
    if (
      err.error?.message?.includes(
        'PDF files must not exceed a total of 10 pages'
      )
    ) {
      this.modalService.open(this.pdfPageLimitModal, { centered: true });
    } else {
      this.toastService.showError(
        'Error' + err.status,
        err.error?.message || 'Could not upload file.'
      );
    }
  }

  async structureData(fileId?: string, clearExistingData?: boolean): Promise<void> {
    this.spreadSheetLoading = true;
    this.structuringTableId = this.activeTable;
    this.previousTab = this.activeTab;
    this.activeTab = 'job-management';
    this.cdRef.detectChanges();
    return new Promise<void>((resolve, reject) => {
      let fileIds: string[] = [];
      let shouldClearExistingData = clearExistingData;

      const isDocumentDataTab = this.previousTab === 'document-data';

      if (fileId) {
        fileIds.push(fileId);
        if (shouldClearExistingData === undefined) {
          shouldClearExistingData = false;
        }
      } else if (isDocumentDataTab && this.files[this.selected_file_index]) {
        const currentFileId = this.files[this.selected_file_index].id;
        if (currentFileId) {
          fileIds.push(currentFileId);
          if (shouldClearExistingData === undefined) {
            shouldClearExistingData = false;
          }
        }
      } else if (this.files.length > 0) {
        const unstructuredFiles = this.files
          .filter((file) => !file.isStructured)
          .map((file) => file.id)
          .filter((id) => id !== undefined && id !== null) as string[];

        if (unstructuredFiles.length > 0) {
          fileIds = unstructuredFiles;
          if (shouldClearExistingData === undefined) {
            shouldClearExistingData = true;
          }
        } else {
          fileIds = this.files
            .map((file) => file.id)
            .filter((id) => id !== undefined && id !== null) as string[];
          
          if (fileIds.length === 0) {
            this.spreadSheetLoading = false;
            this.structuringTableId = '';
            this.toastService.showError(
              'Error',
              'No files available for processing'
            );
            reject();
            return;
          }
          
          shouldClearExistingData = true;
        }
      }

      if (fileIds.length === 0) {
        this.spreadSheetLoading = false;
        this.structuringTableId = '';
        this.toastService.showError(
          'Error',
          'No files available for structuring'
        );
        reject();
        return;
      }

      if (!this.jsonSchema) {
        console.error('structureData failed: No schema available', {
          jsonSchema: this.jsonSchema,
          _setupJsonSchema: this._setupJsonSchema,
          activeTable: this.activeTable,
        });
        this.spreadSheetLoading = false;
        this.structuringTableId = '';
        this.toastService.showError(
          'Error',
          'No schema available for structuring. Please ensure a schema is generated first.'
        );
        reject();
        return;
      }

      const estimatedSeconds = this.calculateStructuringDurationSeconds(fileIds);
      this.beginStructureCountdown(estimatedSeconds, this.activeTable, {
        force: true,
      });

      this.setCurrentTableLoading();

      const fileIdSet = new Set(fileIds);
      this.files = this.files.map((file) => {
        if (file.id && fileIdSet.has(file.id)) {
          this.clearJobManagementState(this.activeTable, file.id);
          return {
            ...file,
            status: 'queued' as const,
            // isStructured: false,
          };
        }
        return file;
      });
      this.updateHasStructuredFiles('structureData');
      this.files_unstructured_count = this.files.filter((f) => !f.isStructured).length;

      // Reset processing progress
      this.processingProgress = {
        current: 0,
        total: fileIds.length,
        processedFiles: [],
        failedFiles: [],
      };

      this.cdRef.detectChanges();

      this.tableExtractor.request(this.activeTable, fileIds, undefined, shouldClearExistingData).subscribe({
        next: (res: any) => {
          console.log('structureData done');
          this.structureSuccessTrigger++;
          this.setTableLoading(this.activeTable, true);
          this.loadTable(this.activeTable, true).then(async () => {
            resolve();
          });
        },
        error: (error: any) => {
          console.error('Error in structure data:', error);
          this.spreadSheetLoading = false;
          this.structuringTableId = '';
          this.clearStructureCountdown();
          this.cancelling = false;
          const message =
            error?.error?.message || error?.message || 'Structuring could not be started or an error occurred. Please try again.';
          this.toastService.showError('Structuring error', message);
          this.setTableLoading(this.activeTable, true);
          reject();
        },
      });
    });
  }

  private refreshCredits(): void {
    this.http.get(`${Config.backend_url}/users/info`).subscribe();
  }

  cancelStructuring(): void {
    this.cancelling = true;
    this.tableExtractor.cancelRequest();

    this.spreadSheetLoading = false;
    this.structuringTableId = '';
    this.clearStructureCountdown();
    this.setTableLoading(this.activeTable, true);

    if (this.activeTab === 'job-management') {
      this.activeTab = this.previousTab !== 'job-management' ? this.previousTab : 'schema';
    }

    this.files = this.files.map((file) => {
      return {
        ...file,
        status:
          file.status === 'processing' || file.status === 'queued'
            ? undefined
            : file.status,
      };
    });
    this.updateHasStructuredFiles('cancelStructuring');

    this.cdRef.detectChanges();
  }

  onRunInBackground(event?: MouseEvent): void {
    if (!event || !event.isTrusted) return;
    this.activeTab = this.previousTab !== 'job-management' ? this.previousTab : 'schema';
    this.toastService.show(
      'info',
      'Structuring continues in the background. You can navigate freely.',
      {
        classname: 'bg-white text-dark position-fixed bottom-0 end-0 mb-7 me-3',
      }
    );
    this.cdRef.detectChanges();
  }

  showJobManagement(): void {
    this.previousTab = this.activeTab;
    this.activeTab = 'job-management';
    this.cdRef.detectChanges();
  }

  onJobManagementCompleted(): void {
    if (this.activeTab === 'job-management') {
      if (this.previousTab === 'document-data') {
        this.activeTab = 'document-data';
        this.loadDocumentData();
      } else {
        this.activeTab = 'spreadsheet';
      }
      this.cdRef.detectChanges();
    }
  }

  getFilesBeingStructured(): { id: string; resourceKey?: string; processId?: string }[] {
    if (!this.isActiveTableStructuring) {
      return [];
    }
    return this.files
      .filter(f => !f.isStructured || f.status === 'processing' || f.status === 'queued')
      .map(f => ({
        id: f.id,
        resourceKey: f.resourceKey,
        processId: f.processId,
      }));
  }

  /** If all structuring jobs have finished (success or failure), clear overlay and show result. Prevents being stuck when backend does not send all-done. */
  private checkStructuringAllDone(): void {
    const total = this.processingProgress.total || 0;
    if (total === 0) return;
    const done =
      this.processingProgress.processedFiles.length + this.processingProgress.failedFiles.length;
    if (done < total) return;

    this.spreadSheetLoading = false;
    this.structuringTableId = '';
    this.setTableLoading(this.activeTable, true);
    this.cancelling = false;
    this.clearStructureCountdown();
    this.refreshCredits();

    const successCount = this.processingProgress.processedFiles.length;
    if (successCount > 0 && this.sheets.length > 0) {
      const message =
        done === successCount
          ? 'Your files were structured successfully. You can add more files or change your spreadsheet format.'
          : `${successCount} of ${done} files were structured successfully. You can add more files or change your spreadsheet format.`;
      this.toastService.show('info', message, {
        classname: 'bg-white text-dark position-fixed bottom-0 end-0 mb-7 me-3',
      });
    } else if (this.processingProgress.failedFiles.length > 0) {
      this.toastService.showError(
        'Structuring completed with errors',
        'One or more files could not be structured. Check the job list for details.'
      );
    }
  }

  private autoSwitchToNextProcessingFile(finishedFileIndex: number): void {
    if (this.activeTab !== 'job-management' || !this.isActiveTableStructuring) {
      return;
    }

    if (this.selected_file_index !== finishedFileIndex) {
      return;
    }

    const nextProcessingIndex = this.files.findIndex((f, idx) => 
      idx !== finishedFileIndex && (f.status === 'processing' || f.status === 'queued')
    );

    if (nextProcessingIndex !== -1) {
      this.selected_file_index = nextProcessingIndex;
      this.cdRef.detectChanges();
    }
  }

  subscribeToStructureObservable() {
    this.structureObservable
      .updates()
      .subscribe(async (data: StructureEvent) => {
        const matchesActiveTable =
          data.tableId == this.activeTable ||
          (!data.tableId && this.structuringTableId === this.activeTable);

        if (matchesActiveTable) {
          console.log('StructureData Event:', data);

          if (data.status === 'all-start') {
            this.processingProgress = {
              current: 0,
              total: this.files.filter((f) => !f.isStructured).length,
              processedFiles: [],
              failedFiles: [],
            };
            if (data.tableId) {
              this.handleStructureCountdownStart(data.tableId);
            }
          }

          if (data.status === 'cancelled') {
            this.spreadSheetLoading = false;
            this.cancelling = false; // Reset cancelling state
            this.structuringTableId = '';
            this.setTableLoading(this.activeTable, true);
            this.clearStructureCountdown();

            if (this.activeTab === 'job-management') {
              this.activeTab = this.previousTab !== 'job-management' ? this.previousTab : 'schema';
            }

            this.files = this.files.map((file) => {
              return {
                ...file,
                status:
                  file.status === 'processing' || file.status === 'queued'
                    ? undefined
                    : file.status,
              };
            });
            this.updateHasStructuredFiles('structureCancelled');

            this.refreshCredits();

            this.toastService.show(
              'info',
              'Structuring operation was cancelled',
              {
                classname:
                  'bg-white text-dark position-fixed bottom-0 end-0 mb-7 me-3',
              }
            );
          }

          if (data.status === 'segments') {
            const provenance = this.files[this.selected_file_index].provenance || { segments: [], items: [] };
            provenance.segments = data.segments as Segment[];
            const file_index = this.files.findIndex((f) => f.id === data.fileId);
            // Switch to file?
            if (file_index > -1) {
              this.files[file_index].provenance = provenance as Provenance;
              await this.selectFile(file_index);
              this.setActiveView('content');
              this.cdRef.detectChanges();
            }
            // Alternatively, only update if file already selected
            //if (file_index === this.selected_file_index) {
            //  this.files[file_index].provenance = provenance as Provenance;
            //  this.setSelectedFileSegments(provenance.segments);
            //  this.setActiveView('content');
            //  this.cdRef.detectChanges();
            //}
          }

          if (data.fileId) {
            const fileIndex = this.files
              .map((file) => file.id)
              .indexOf(data.fileId);
            const file = this.files[fileIndex];
            if (fileIndex > -1) {
              switch (data.status) {
                case 'queued':
                  this.files = this.files.map((f, i) => 
                    i === fileIndex ? { ...f, status: 'queued' as const } : f
                  );
                  this.updateHasStructuredFiles('structureStatus-queued');
                  break;
                case 'processing':
                  this.files = this.files.map((f, i) => 
                    i === fileIndex ? { ...f, status: 'processing' as const } : f
                  );
                  this.updateHasStructuredFiles('structureStatus-processing');
                  if (data.progress) {
                    this.processingProgress = data.progress;
                  }
                  break;
                case 'failed':
                  this.toastService.showError(
                    'File not processed',
                    `File '${file.name}' could not be successfully validated.`
                  );
                  this.files = this.files.map((f, i) => 
                    i === fileIndex ? { ...f, status: 'failed' as const } : f
                  );
                  this.updateHasStructuredFiles('structureStatus-failed');
                  if (!this.processingProgress.failedFiles.includes(data.fileId)) {
                    this.processingProgress = {
                      ...this.processingProgress,
                      failedFiles: [...this.processingProgress.failedFiles, data.fileId],
                      current: this.processingProgress.current + 1
                    };
                  }
                  this.checkStructuringAllDone();
                  break;
                case 'finished':
                  if (!this.processingProgress.processedFiles.includes(data.fileId)) {
                    this.files = this.files.map((f, i) => 
                      i === fileIndex ? { ...f, status: 'finished' as const, isStructured: true } : f
                    );
                    this.updateHasStructuredFiles('structureStatus-finished');
                    this.processingProgress = {
                      ...this.processingProgress,
                      processedFiles: [...this.processingProgress.processedFiles, data.fileId],
                      current: this.processingProgress.current + 1
                    };
                    this.autoSwitchToNextProcessingFile(fileIndex);
                  } else {
                    this.files = this.files.map((f, i) => 
                      i === fileIndex ? { ...f, status: 'finished' as const, isStructured: true } : f
                    );
                    this.updateHasStructuredFiles('structureStatus-finished (else)');
                  }
                  this.checkStructuringAllDone();
                  break;
                case 'table':
                  if (!this.processingProgress.processedFiles.includes(data.fileId)) {
                    this.files = this.files.map((f, i) => 
                      i === fileIndex ? { ...f, status: 'finished' as const, isStructured: true } : f
                    );
                    this.updateHasStructuredFiles('structureStatus-table');
                    this.processingProgress = {
                      ...this.processingProgress,
                      processedFiles: [...this.processingProgress.processedFiles, data.fileId],
                      current: this.processingProgress.current + 1
                    };
                    this.autoSwitchToNextProcessingFile(fileIndex);
                  } else {
                    this.files = this.files.map((f, i) => 
                      i === fileIndex ? { ...f, status: 'finished' as const, isStructured: true } : f
                    );
                    this.updateHasStructuredFiles('structureStatus-table (else)');
                  }
                  this.checkStructuringAllDone();
                  break;
                default:
                  this.files = this.files.map((f, i) => {
                    if (i === fileIndex) {
                      const { status, ...rest } = f;
                      return rest as typeof f;
                    }
                    return f;
                  });
                  this.updateHasStructuredFiles('structureStatus-default');
              }
            }
          }

          if (data.status === 'all-done') {
            const successfullyProcessedCount =
              this.processingProgress.processedFiles.length;
            const totalProcessedCount =
              this.processingProgress.processedFiles.length +
              this.processingProgress.failedFiles.length;

            this.spreadSheetLoading = false;
            this.structuringTableId = ''; // Clear structuring table ID
            this.setTableLoading(this.activeTable, true);
            this.cancelling = false;
            this.clearStructureCountdown();

            // Tab switch is now handled by job-management component's (completed) event
            // to allow the validation animation to finish

            this.refreshCredits();

            if (successfullyProcessedCount > 0 && this.sheets.length > 0) {
              const message =
                totalProcessedCount === successfullyProcessedCount
                  ? 'Your files got structured successfully. You can now add more files or change your spreadsheet format.'
                  : `${successfullyProcessedCount} of ${totalProcessedCount} files were structured successfully. You can now add more files or change your spreadsheet format.`;

              this.toastService.show('info', message, {
                classname:
                  'bg-white text-dark position-fixed bottom-0 end-0 mb-7 me-3',
              });
            }

            if (successfullyProcessedCount > 0 && this.activeTable) {
              this.loadTable(this.activeTable, true).then(() => {
                if (this.activeTab === 'document-data') {
                  this.loadDocumentData();
                }
                this.cdRef.detectChanges();
              });
            }
          }

          if (data.table) {
            this.sheets = data.table;
            const sheetIndex = Math.max(
              this.sheets.findIndex(
                (sheet) => sheet.id == this.activeSheet?.id
              ),
              0
            );
            this.activeSheet = this.sheets[sheetIndex];
            this.activeSheetObservable.setActiveSheet(this.activeSheet.id);
          }

          this.cdRef.detectChanges();
        }
      });
  }

  subscribeToFileUploadObservable() {
    this.fileUploadObservable.updates().subscribe((data: FileUploadEvent) => {
      console.log('FileUploadEvent:', data);

      if (data.generating_schema) {
        this.isGeneratingSchema = true;
        // Lock the user into the generating-schema tab and spreadsheet view
        this.activeTab = 'generating-schema';

        if (data.file) {
          if (!this.tableHasFile) {
            this.tableHasFile = true;
          }
          if (this.files.length === 0) {
          }
        }

        this.schemaGenerationStates.set(this.activeTable, {
          isGenerating: true,
          activeTab: 'generating-schema',
          tableHasFile: this.tableHasFile,
          filesCurrentlyUploading: this.filesCurrentlyUploading,
          signedUrl: this.signedUrl,
          fileMimeType: this._fileMimeType
        });
      } else {
        
        if (!this.isUploadInProgress && this.filesCurrentlyUploading <= 1) {
          this.filesCurrentlyUploading = 0;
        }
        this.isGeneratingSchema = false;
        this.cdRef.detectChanges();
        this.schemaGenerationStates.set(this.activeTable, {
          isGenerating: false,
          activeTab: 'schema',
          tableHasFile: this.tableHasFile,
          filesCurrentlyUploading: this.filesCurrentlyUploading,
          signedUrl: this.signedUrl,
          fileMimeType: this._fileMimeType
        });
      }
      if (data.fileSignedUrl) {
        const shouldPreviewFile =
          this.files.length === 0 || this.filesCurrentlyUploading === 1;

        console.log('WebSocket file preview decision:', {
          fileId: data.fileId,
          filesLength: this.files.length,
          filesCurrentlyUploading: this.filesCurrentlyUploading,
          shouldPreviewFile,
          currentSignedUrl: this.signedUrl,
        });

        if (shouldPreviewFile) {
          const newSignedUrl = data.fileSignedUrl || data.file?.signedUrl;
          if (newSignedUrl && newSignedUrl !== this.signedUrl) {
            if (data.file) {
              this.setFile({
                signedUrl: newSignedUrl,
                mimeType: data.file.mimeType,
              });
            } else {
              this.setFile({ signedUrl: newSignedUrl });
            }
            console.log('WebSocket updated file preview to:', newSignedUrl);
          } else {
            console.log('WebSocket skipped duplicate file preview update');
          }
        }
      }
    });
  }

  subscribeToCreditCountObservable() {
    this.creditCountObservable.updates().subscribe((count: number) => {
      this.creditCount = count;
    });
  }

  subscribeToSidebarToggleObservable() {
    this.sidebarToggleObservable.toggled$.subscribe((isOpen: boolean) => {
      console.log('🔍 SHELL DEBUG - sidebar state changed to:', isOpen);
      this.isSidebarOpen = isOpen;
    });
  }

  initializeSidebarState() {
    const savedExpanded = localStorage.getItem('sidebarExpanded');
    if (savedExpanded !== null) {
      this.isSidebarOpen = JSON.parse(savedExpanded);
      console.log(
        '🔍 SHELL DEBUG - initialized sidebar state from localStorage:',
        this.isSidebarOpen
      );
    } else {
      // Default to true (expanded) if no saved state
      this.isSidebarOpen = true;
      console.log(
        '🔍 SHELL DEBUG - initialized sidebar state to default (true)'
      );
    }
  }

  async newWorkspaceOrDataset(containerId?: UUID, type?: string, name?: string) {
    if (type === 'dataspace') {
      this.isNewDataspaceCreated = true;
      this.setFile();
      this.jsonSchema = '';
      this.files = [];
      this.updateHasStructuredFiles('newWorkspaceOrDataset');
      this.filesCurrentlyUploading = 0;
      this.tableHasFile = false;
      this.files_unstructured_count = 0;
      this.isGeneratingSchema = false; 
      this.isManualModeUploadInProgress = false; 
      this.isUploadInProgress = false; 
      this.cdRef.detectChanges();
    }

    this.loading = true;
    if (type !== 'dataspace') {
      this.setFile();
    }

    return new Promise<void>((resolve, reject) => {
      const payload: any = {
        containerId: containerId ? containerId : '',
        type,
      };
      
      if (name) {
        payload.tableName = name;
      }
      
      this.tableService
        .createTables(payload)
        .subscribe({
          next: async (res: CreateNewTableDto) => {
            if (containerId) {
              this.activeContainer = containerId;
            }
            this.loading = false;

            if (res.data?.tableId) {
              try {
                await this.loadTable(res.data?.tableId);
                this.activeTable = res.data?.tableId;
              } catch (error) {
                reject(error);
                return;
              }
            }
            resolve();
          },
          error: (err) => {
            this.loading = false;
            reject(err);
          },
        });
    });
  }

  getOAuthUser() {
    this.googleService.getOAuthUser().subscribe({
      next: (res: any) => {
        console.log('res', res);
        this.gOauthData = res.data;
        this.gOauthData.filter((_gAuth: any) => {
          if (_gAuth.type === 'analytics') {
            this.gOauthFlag.analytics = true;
          }
          if (_gAuth.type === 'ads') {
            this.gOauthFlag.ads = true;
          }
        });
      },
    });
  }

  onInvalidFiles(files: File[]) {
    files.forEach((file) => {
      this.toastService.showError(
        'Invalid File',
        `File type not allowed: ${file.name}`
      );
    });
  }

  get unstructuredFilesCount(): number {
    return this.files.filter((f) => !f.isStructured).length;
  }

  get totalCreditsRequired(): number {
    return this.files
      .filter((f) => !f.isStructured)
      .reduce((sum, file) => sum + (file.creditCost || 1), 0);
  }

  get structureButtonText(): string {
    if (this.activeTab === 'document-data') {
      const currentFile = this.files[this.selected_file_index];
      if (this.spreadSheetLoading) {
        const countdownSuffix = this.structureCountdownDisplay
          ? ` (${this.structureCountdownDisplay} left)`
          : '';
        return `Processing${countdownSuffix}...`;
      }
      if (!currentFile) {
        return 'Structure Document';
      }
      if (currentFile.isStructured) {
        return 'Restructure Document';
      }
      return 'Structure Document';
    }

    // Dataspace Data or other tabs - show all files text
    const count = this.unstructuredFilesCount;
    if (count === 0) {
      return 'Restructure All';
    }
    if (this.spreadSheetLoading) {
      const processed = this.processingProgress.current + 1;
      const total = this.processingProgress.total;
      const countdownSuffix = this.structureCountdownDisplay
        ? ` (${this.structureCountdownDisplay} left)`
        : '';
      if (total > 0) {
        return `Processing File ${processed}/${total}${countdownSuffix}...`;
      }
      return `Processing${countdownSuffix}...`;
    }
    return `Structure ${count} File${count > 1 ? 's' : ''}`;
  }

  get isStructureButtonDisabled(): boolean {
    // Check if we're on Document Data tab - enable for single file restructure
    if (this.activeTab === 'document-data') {
      const currentFile = this.files[this.selected_file_index];
      return (
        !currentFile ||
        this.spreadSheetLoading ||
        this.cancelling ||
        !this.hasSufficientCreditsForFile(currentFile) ||
        !this.jsonSchema
      );
    }

    return (
      this.files.length === 0 ||
      this.spreadSheetLoading ||
      this.cancelling ||
      !this.hasSufficientCredits ||
      !this.jsonSchema
    );
  }

  private hasSufficientCreditsForFile(file: { creditCost?: number } | undefined): boolean {
    if (!file) return false;
    const creditCost = file.creditCost || 1;
    return this.creditCount >= creditCost;
  }

  get canCancelStructuring(): boolean {
    return this.spreadSheetLoading && !this.cancelling;
  }

  getStructureButtonTooltip(): string {
    if (this.activeTab === 'document-data') {
      const currentFile = this.files[this.selected_file_index];
      
      if (!currentFile) {
        return 'No document selected. Select a document to structure.';
      }
      if (this.spreadSheetLoading) {
        return 'Processing...';
      }
      if (!this.hasSufficientCreditsForFile(currentFile)) {
        const creditsNeeded = currentFile.creditCost || 1;
        const creditsAvailable = this.creditCount;
        return `Insufficient credits. You need ${creditsNeeded} credits but only have ${creditsAvailable}. Contact sales to structure more data.`;
      }
      if (!this.jsonSchema) {
        return 'No template provided. Please provide a few data points you would like to extract to structure your data.';
      }
      
      const creditsRequired = currentFile.creditCost || 1;
      const estimatedSeconds = currentFile.estimatedProcessingTimeSeconds || this.estimatedProcessingTimeSeconds;
      
      let tooltip = currentFile.isStructured
        ? `Click to restructure this document with the current template.\n\nCredits required: ${creditsRequired}`
        : `Click to structure this document.\n\nCredits required: ${creditsRequired}`;
      
      if (estimatedSeconds != null) {
        const totalSeconds = Math.ceil(estimatedSeconds);
        let minutes = Math.ceil(totalSeconds / 60);
        if (minutes === 0) {
          minutes = 1;
        }
        tooltip += `\n\nEstimated time to process: ~${minutes} minute${minutes === 1 ? '' : 's'}`;
      }
      
      return tooltip;
    }

    if (this.spreadSheetLoading) {
      return 'Processing...';
    }
    if (this.files.length === 0) {
      return 'No files uploaded. Upload files to structure your data.';
    }
    if (!this.hasSufficientCredits) {
      const creditsNeeded = this.totalCreditsRequired;
      const creditsAvailable = this.creditCount;
      return `Insufficient credits. You need ${creditsNeeded} credits but only have ${creditsAvailable}. Contact sales to structure more data.`;
    }
    if (!this.jsonSchema) {
      return 'No template provided. Please provide a few data points you would like to extract to structure your data.';
    }

    const unstructuredCount = this.unstructuredFilesCount;
    const creditsRequired = this.totalCreditsRequired;

    const estimatedSecondsFromFiles = this.files
      .filter((f) => !f.isStructured)
      .reduce((sum, file) => sum + (file.estimatedProcessingTimeSeconds || 0), 0);

    const estimatedSeconds =
      estimatedSecondsFromFiles > 0
        ? estimatedSecondsFromFiles
        : this.estimatedProcessingTimeSeconds;

    let tooltip: string;
    let timeEstimateSeconds: number | null = null;

    if (unstructuredCount === 0) {
      // Restructure All scenario
      const totalCredits = this.files.reduce((sum, f) => sum + (f.creditCost || 1), 0);
      tooltip = `Click to restructure all files with the current template. This will clear existing data and re-extract from all documents.\n\nCredits required: ${totalCredits}`;
      
      // Calculate time for all files
      timeEstimateSeconds = this.files.reduce((sum, file) => sum + (file.estimatedProcessingTimeSeconds || 0), 0);
      if (timeEstimateSeconds === 0) {
        timeEstimateSeconds = this.estimatedProcessingTimeSeconds;
      }
    } else {
      tooltip = `Click to structure your data.\n\nCredits required: ${creditsRequired}`;
      timeEstimateSeconds = estimatedSeconds;
    }

    if (timeEstimateSeconds != null && timeEstimateSeconds > 0) {
      const totalSeconds = Math.ceil(timeEstimateSeconds);
      let minutes = Math.ceil(totalSeconds / 60);
      if (minutes === 0) {
        minutes = 1;
      }
      tooltip += `\n\nEstimated time to process: ~${minutes} minute${
        minutes === 1 ? '' : 's'
      }`;
    }

    return tooltip;
  }

  private calculateStructuringDurationSeconds(fileIds: string[]): number | null {
    if (!fileIds || fileIds.length === 0) {
      return this.estimatedProcessingTimeSeconds;
    }

    const targetIds = new Set(fileIds);
    const secondsFromFiles = this.files.reduce((sum, file) => {
      if (file.id && targetIds.has(file.id)) {
        return sum + (file.estimatedProcessingTimeSeconds || 0);
      }
      return sum;
    }, 0);

    if (secondsFromFiles > 0) {
      return secondsFromFiles;
    }

    if (this.estimatedProcessingTimeSeconds != null) {
      return this.estimatedProcessingTimeSeconds;
    }

    return (
      fileIds.length * this.DEFAULT_PROCESSING_TIME_PER_FILE_SECONDS || null
    );
  }

  private beginStructureCountdown(
    durationSeconds: number | null,
    tableId?: string,
    options?: { force?: boolean }
  ): void {
    if (!tableId || durationSeconds == null || durationSeconds <= 0) {
      return;
    }

    if (this.structureCountdownState) {
      if (
        this.structureCountdownState.tableId === tableId &&
        !options?.force
      ) {
        return;
      }
      this.clearStructureCountdown();
    }

    const durationMs = durationSeconds * 1000;
    const now = Date.now();
    const state: StructureCountdownState = {
      tableId,
      durationMs,
      startedAt: now,
      endTime: now + durationMs,
    };
    this.structureCountdownState = state;
    this.persistStructureCountdownState(state);
    this.startStructureCountdownTicker(state);
  }

  private handleStructureCountdownStart(tableId: string): void {
    if (!tableId) {
      return;
    }

    if (this.structureCountdownState?.tableId === tableId) {
      return;
    }

    const fileIds = this.files
      .filter((file) => !file.isStructured && !!file.id)
      .map((file) => file.id!);

    const estimatedSeconds = this.calculateStructuringDurationSeconds(fileIds);
    this.beginStructureCountdown(estimatedSeconds, tableId);
  }

  private startStructureCountdownTicker(
    state: StructureCountdownState
  ): void {
    this.stopStructureCountdownTicker();
    this.updateStructureCountdownDisplay(state.endTime);
    this.structureCountdownIntervalId = setInterval(() => {
      this.updateStructureCountdownDisplay(state.endTime);
    }, 1000);
  }

  private stopStructureCountdownTicker(): void {
    if (this.structureCountdownIntervalId) {
      clearInterval(this.structureCountdownIntervalId);
      this.structureCountdownIntervalId = null;
    }
  }

  private updateStructureCountdownDisplay(endTime: number): void {
    const remainingMs = endTime - Date.now();
    if (remainingMs <= 0) {
      this.structureCountdownDisplay = '00:00';
      this.stopStructureCountdownTicker();
      this.cdRef.markForCheck();
      return;
    }

    this.structureCountdownDisplay = this.formatCountdown(remainingMs);
    this.cdRef.markForCheck();
  }

  private formatCountdown(remainingMs: number): string {
    const totalSeconds = Math.max(0, Math.ceil(remainingMs / 1000));
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (hours > 0) {
      return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds
        .toString()
        .padStart(2, '0')}`;
    }

    return `${minutes.toString().padStart(2, '0')}:${seconds
      .toString()
      .padStart(2, '0')}`;
  }

  private clearStructureCountdown(options?: {
    keepStorage?: boolean;
    keepLoadingFlag?: boolean;
  }): void {
    this.stopStructureCountdownTicker();
    this.structureCountdownDisplay = null;
    this.structureCountdownState = null;
    if (!options?.keepLoadingFlag) {
      this.spreadSheetLoading = false;
    }

    if (!options?.keepStorage) {
      this.removeStructureCountdownState();
    }
  }

  private restoreStructureCountdownFromStorage(
    expectedTableId?: string
  ): void {
    if (!this.isBrowserEnvironment()) {
      return;
    }

    if (
      this.structureCountdownState &&
      (!expectedTableId ||
        this.structureCountdownState.tableId === expectedTableId)
    ) {
      return;
    }

    const storedState = this.readStructureCountdownStateFromStorage();
    if (!storedState) {
      return;
    }

    if (expectedTableId && storedState.tableId !== expectedTableId) {
      return;
    }

    if (storedState.endTime <= Date.now()) {
      this.clearStructureCountdown();
      return;
    }

    this.structureCountdownState = storedState;
    this.startStructureCountdownTicker(storedState);
    this.structuringTableId = storedState.tableId;
    this.spreadSheetLoading = true;
    this.cdRef.markForCheck();
  }

  private persistStructureCountdownState(
    state: StructureCountdownState
  ): void {
    if (!this.isBrowserEnvironment()) {
      return;
    }

    try {
      localStorage.setItem(
        this.STRUCTURE_COUNTDOWN_STORAGE_KEY,
        JSON.stringify(state)
      );
    } catch (error) {
      console.error('Unable to save structuring countdown state', error);
    }
  }

  private readStructureCountdownStateFromStorage():
    | StructureCountdownState
    | null {
    if (!this.isBrowserEnvironment()) {
      return null;
    }

    try {
      const raw = localStorage.getItem(
        this.STRUCTURE_COUNTDOWN_STORAGE_KEY
      );
      if (!raw) {
        return null;
      }
      return JSON.parse(raw) as StructureCountdownState;
    } catch (error) {
      console.error('Unable to read structuring countdown state', error);
      return null;
    }
  }

  private removeStructureCountdownState(): void {
    if (!this.isBrowserEnvironment()) {
      return;
    }

    try {
      localStorage.removeItem(this.STRUCTURE_COUNTDOWN_STORAGE_KEY);
    } catch (error) {
      console.error('Unable to clear structuring countdown state', error);
    }
  }

  private isBrowserEnvironment(): boolean {
    return typeof window !== 'undefined' && typeof localStorage !== 'undefined';
  }

  private clearJobManagementState(tableId: string, fileId: string): void {
    if (!this.isBrowserEnvironment()) return;
    
    try {
      const storageKey = 'job_management_states';
      const stored = localStorage.getItem(storageKey);
      if (stored) {
        const allStates = JSON.parse(stored);
        const stateKey = `${tableId}:${fileId}`;
        if (allStates[stateKey]) {
          delete allStates[stateKey];
          localStorage.setItem(storageKey, JSON.stringify(allStates));
        }
      }
    } catch (e) {
    }
  }

  onWorkflowSelect(type: 'semi' | 'manual'): void {
    this.workflowType = type;

    console.log('Workflow type changed to:', this.workflowType);
  }

  private selectedTemplate: SchemaResponse | null = null;

  async onTemplateSelected(template: SchemaResponse): Promise<void> {
    console.log(
      'Template selected, applying using schema builder API pattern:',
      template.schema_name
    );

    this.selectedTemplate = template;
    sessionStorage.setItem('selectedTemplate', JSON.stringify(template));

    if (!this.activeTable) {
      console.log('No active table found, creating new dataspace for template');
      try {
        await this.newWorkspaceOrDataset('', 'dataspace');
        console.log(
          'New dataspace created, activeTable is now:',
          this.activeTable
        );
      } catch (error) {
        console.error('Failed to create new dataspace for template:', error);
        return;
      }
    }

    this.tableService
      .updateTable(this.activeTable, { schema_id: template.schema_id })
      .subscribe({
        next: () => {
          console.log('Table updated with schema_id');
          if (template.schema_content) {
            this.tableService
              .addSchemaToDataspace(
                template.schema_content,
                this.activeTable,
                template.schema_id,
                this.schemaSettings,
                template.schema_config?.configuration?.sheets
              )
              .subscribe({
                next: (result) => {
                  console.log('Template successfully applied to dataspace');
                },
                error: (error: any) => {
                  console.error(
                    'Failed to apply template to dataspace:',
                    error
                  );
                },
              });
          }
        },
        error: (error: any) => {
          console.error('Failed to update table with schema_id:', error);
        },
      });
  }

  private async applySelectedTemplate(template: SchemaResponse): Promise<void> {
    console.log(
      'Applying selected template after file upload:',
      template.schema_name
    );

    if (!this.activeTable) {
      console.error('No active table found for template application');
      return;
    }
    this.tableService
      .updateTable(this.activeTable, { schema_id: template.schema_id })
      .subscribe({
        next: () => {
          console.log('Table updated with schema_id after file upload');
          if (template.schema_content) {
            this.tableService
              .addSchemaToDataspace(
                template.schema_content,
                this.activeTable,
                template.schema_id,
                this.schemaSettings,
                template.schema_config?.configuration?.sheets
              )
              .subscribe({
                next: (result) => {
                  console.log(
                    'Template successfully applied to dataspace after file upload'
                  );

                  this.schema_id = template.schema_id;
                  this.schema_name = template.schema_name;
                  this.jsonSchema = JSON.stringify(template.schema_content);

                  // Delay resetting filesCurrentlyUploading to prevent view flicker
                  setTimeout(() => {
                    this.filesCurrentlyUploading = 0;
                    this.isManualModeUploadInProgress = false;
                    this.cdRef.detectChanges();
                  }, 0);

                  this.toastService.show(
                    'info',
                    `Template "${template.schema_name}" has been applied to your uploaded file.`,
                    {
                      classname:
                        'bg-white text-dark position-fixed bottom-0 end-0 mb-7 me-3',
                    }
                  );
                },
                error: (error: any) => {
                  console.error(
                    'Failed to apply template to dataspace after file upload:',
                    error
                  );
                  // Delay resetting filesCurrentlyUploading to prevent view flicker
                  setTimeout(() => {
                    this.filesCurrentlyUploading = 0;
                    this.isManualModeUploadInProgress = false;
                    this.cdRef.detectChanges();
                  }, 0);
                },
              });
          }
        },
        error: (error: any) => {
          console.error(
            'Failed to update table with schema_id after file upload:',
            error
          );
          // Reset the upload loading state even on error
          // Delay resetting filesCurrentlyUploading to prevent view flicker
          setTimeout(() => {
            this.filesCurrentlyUploading = 0;
            this.isManualModeUploadInProgress = false;
            this.cdRef.detectChanges();
          }, 0);
        },
      });
  }

  get showRightSlide(): boolean {
    if (this.isApplyingTemplateSilently) {
      console.log('showRightSlide blocked by silent flag');
      return false;
    }

    if (this.isNewDataspaceCreated && this.files.length === 0 && this.filesCurrentlyUploading === 0 && !this.loading) {
      return false;
    }
    return !!(
      this.loading ||
      this.jsonSchema ||
      this.files.length > 0 ||
      this.isGeneratingSchema ||
      this.filesCurrentlyUploading > 0 ||
      this.isManualModeUploadInProgress
    );
  }

  showSchemaBuilderTooltip() {
    if (this.userService.userInfo.doNotShowTemplateBuilderTooltip) {
      return;
    }

    if (this.schemaBuilderPopupTimeout) {
      clearTimeout(this.schemaBuilderPopupTimeout);
    }
    this.showSchemaBuilderPopup = true;
    this.schemaBuilderPopupTimeout = setTimeout(() => {
      this.showSchemaBuilderPopup = false;
    }, 20000);
  }

  hideSchemaBuilderTooltip() {
    this.showSchemaBuilderPopup = false;
    if (this.schemaBuilderPopupTimeout) {
      clearTimeout(this.schemaBuilderPopupTimeout);
    }
  }

  onDoNotShowAgainChange(event: Event) {
    const checkbox = event.target as HTMLInputElement;
    if (!checkbox) return;

    const updateData = {
      doNotShowTemplateBuilderTooltip: checkbox.checked,
    };

    this.userService.updateUser(updateData).subscribe({
      next: (response: any) => {
        const updatedUserInfo = {
          ...this.userService.userInfo,
          doNotShowTemplateBuilderTooltip: checkbox.checked,
        };
        this.userService.userInfo = updatedUserInfo;

        this.userInfoObservable.registerNewUpdate(updatedUserInfo);

        if (checkbox.checked) {
          this.hideSchemaBuilderTooltip();
        }
      },
      error: (error) => {
        console.error('Error updating user preference:', error);
      },
    });
  }

  get isActiveTableStructuring(): boolean {
    return (
      this.structuringTableId === this.activeTable && this.spreadSheetLoading
    );
  }

  get activeTable(): string {
    return this.activeSheetObservable.getActiveTable();
  }
  set activeTable(value: string) {
    this.activeSheetObservable.setActiveTable(value);
  }

  get activeTableName(): string {
    return this.activeSheetObservable.getActiveTableName();
  }

  set activeTableName(name: string) {
    this.activeSheetObservable.setActiveTableName(name);
  }

  onSplitterMouseDown(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();

    this.isDragging = true;
    this.startX = event.clientX;
    this.startLeftWidth = this.leftPanelWidth;

    document.body.classList.add('dragging-splitter');

    const mouseMoveHandler = (e: MouseEvent) => this.handleMouseMove(e);
    const mouseUpHandler = (e: MouseEvent) =>
      this.handleMouseUp(e, mouseMoveHandler, mouseUpHandler);

    document.addEventListener('mousemove', mouseMoveHandler);
    document.addEventListener('mouseup', mouseUpHandler);

    document.addEventListener('mouseleave', mouseUpHandler);
  }

  private handleMouseMove(event: MouseEvent): void {
    if (!this.isDragging) return;

    event.preventDefault();
    event.stopPropagation();

    const containerElement = document.getElementById('content');
    if (!containerElement) return;

    const containerWidth = containerElement.offsetWidth;
    const deltaX = event.clientX - this.startX;
    const deltaPercent = (deltaX / containerWidth) * 100;

    let newLeftWidth = this.startLeftWidth + deltaPercent;

    const minWidthPercent = (300 / containerWidth) * 100;
    const maxWidthPercent = 100 - minWidthPercent - (4 / containerWidth) * 100;

    newLeftWidth = Math.max(
      minWidthPercent,
      Math.min(maxWidthPercent, newLeftWidth)
    );

    this.leftPanelWidth = newLeftWidth;
    this.cdRef.detectChanges();
  }

  private handleMouseUp(
    event: MouseEvent,
    mouseMoveHandler: (e: MouseEvent) => void,
    mouseUpHandler: (e: MouseEvent) => void
  ): void {
    event.preventDefault();
    event.stopPropagation();

    this.isDragging = false;

    document.removeEventListener('mousemove', mouseMoveHandler);
    document.removeEventListener('mouseup', mouseUpHandler);
    document.removeEventListener('mouseleave', mouseUpHandler);

    document.body.classList.remove('dragging-splitter');
  }

  get rightPanelWidth(): number {
    return 100 - this.leftPanelWidth;
  }

  resetSegmentView() {
    const segmentElements = document.querySelectorAll('.segment-element');
    segmentElements.forEach(element => {
      element.classList.remove('highlight');
      const highlightElements = element.querySelectorAll('.inline-highlight');
      highlightElements.forEach(highlightElement => {
        highlightElement.classList.remove('inline-highlight');
      });
    });
    window.getSelection()?.removeAllRanges();
    this.cdRef.detectChanges();
  }

  highlightSegment(segmentId: number, value? : string | number | boolean | null) {
    this.resetSegmentView();
    const segmentElement = document.getElementById(`segment-${segmentId}`);
    if (segmentElement) {
      segmentElement.scrollIntoView({ behavior: 'smooth' });
      segmentElement.classList.add('highlight');
      
      // Select the exact value if safe
      const searchText = value == null ? '' : String(value);
      if (searchText) {
        const textContent = segmentElement.textContent || '';
        const firstIndex = textContent.indexOf(searchText);
        if (
          firstIndex !== -1 &&
          firstIndex === textContent.lastIndexOf(searchText) // Only select if text is only present once
        ) {
          const endIndex = firstIndex + searchText.length;
          const range = this.createRangeForSegmentText(
            segmentElement,
            firstIndex,
            endIndex
          );
          if (range) {
            const selection = window.getSelection();
            if (selection) {
              selection.removeAllRanges();
              selection.addRange(range);
            }
          }
        }
      }
    }
    this.cdRef.detectChanges();
  }

  private createRangeForSegmentText(
    element: Element,
    startIndex: number,
    endIndex: number
  ): Range | null {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null);
    let currentNode = walker.nextNode() as Text | null;
    let accumulated = 0;
    let startNode: Text | null = null;
    let endNode: Text | null = null;
    let startOffset = 0;
    let endOffset = 0;

    while (currentNode) {
      const nodeText = currentNode.textContent || '';
      const nodeStart = accumulated;
      const nodeEnd = accumulated + nodeText.length;

      if (
        startNode === null &&
        startIndex >= nodeStart &&
        startIndex <= nodeEnd
      ) {
        startNode = currentNode;
        startOffset = Math.min(nodeText.length, startIndex - nodeStart);
      }

      if (
        startNode &&
        endNode === null &&
        endIndex >= nodeStart &&
        endIndex <= nodeEnd
      ) {
        endNode = currentNode;
        endOffset = Math.min(nodeText.length, endIndex - nodeStart);
        break;
      }

      accumulated = nodeEnd;
      currentNode = walker.nextNode() as Text | null;
    }

    if (!startNode || !endNode) {
      return null;
    }

    const range = document.createRange();
    range.setStart(startNode, startOffset);
    range.setEnd(endNode, endOffset);
    return range;
  }

  async onCellClicked(event: CellClickedEvent) {
    console.log('Cell clicked event received');
    console.log(event);
    this.resetSegmentView();
    if (event.tableId !== this.activeTable) return; // Shouldn't ever happen
    const clicked_file_index = this.files.findIndex(file => file.id === event.cellMeta.fileId);
    const clicked_file = this.files[clicked_file_index];
    if (clicked_file_index != this.selected_file_index) {
      await this.selectFile(clicked_file_index);
    }
    if (clicked_file?.provenance?.segments?.length) {
      this.setSelectedFileSegments(clicked_file.provenance?.segments || []);
      this.activeView = 'content';
      this.cdRef.detectChanges();
      if (event.cellMeta.segmentId) {
        this.highlightSegment(event.cellMeta.segmentId, event.value);
      }
    }
  }

  copyToClipboardDatasetQualityInfoClick(): void {
    navigator.clipboard.writeText(`
      Job ID: ${this.documentDataFileInfo?.jobId};\n
      Score: ${this.documentDataFileInfo?.score};\n
      Quality: ${this.documentDataFileInfo?.quality};\n
      Summary: total_fields: ${this.documentDataFileInfo?.summary?.total_fields}, fields_with_value: ${this.documentDataFileInfo?.summary?.fields_with_value}, fields_empty: ${this.documentDataFileInfo?.summary?.fields_empty}
    `).then(() => {
      this.toastService.showSuccess('Copied!', 'Dataset quality info copied to clipboard');
    });
  }

  getUserRole(): string {
    return this.userService.userInfo.role || '';
  }

  openSchemaSettings(): void {
    const modalRef = this.modalService.open(SchemaSettingsModalComponent, { size: 'sm', centered: true, windowClass: 'schema-settings-modal' });
    modalRef.componentInstance.settings = this.schemaSettings;
    modalRef.result
      .then((result: SchemaSettings) => {
        if (result) {
          console.log('schemaSettings updated', result);
          this.schemaSettings = { ...result };
          if (this.activeTable && this.jsonSchema) {
            this.tableService.addSchemaToDataspace(
              this.jsonSchema,
              this.activeTable,
              this.schema_id,
              this.schemaSettings,
              this.schemaConfig?.configuration?.sheets
            ).subscribe({
              next: () => {
                console.log('Schema settings saved');
              },
              error: (error: any) => {
                console.error('Failed to save schema settings:', error);
              }
            });
          }
        }
      })
      .catch(() => {});
  }

  private getSchemaSettings(schemaConfig: any): SchemaSettings {
    const defaults = this.defaultSchemaSettings;
    const config = schemaConfig?.configuration;
    if (!config) {
      return { ...defaults };
    }

    return {
      requireProvenance: config.require_provenance ?? defaults.requireProvenance,
      fastConversion: config.fast_conversion ?? defaults.fastConversion,
      multiple_rows: config.multiple_rows ?? defaults.multiple_rows,
      schemaSplittingThreshold: config.schema_splitting_threshold ?? defaults.schemaSplittingThreshold,
      n_shot: config.n_shot ?? defaults.n_shot
    };
  }

  ngOnDestroy() {
    if (this.isDragging) {
      this.isDragging = false;
      document.body.classList.remove('dragging-splitter');
    }
    this.clearStructureCountdown({ keepStorage: true, keepLoadingFlag: true });
    this.schemaGenerationStates.clear();
  }
}
